module.exports = __webpack_public_path__ + "img/pollo_n11.bd314c60.svg";